// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2LSap","header":"ReportDetails_header__2M8sf","title":"ReportDetails_title__3uq9U","left":"ReportDetails_left__1sxxE"};